import {BrowserModule} from '@angular/platform-browser';
import {MatIconModule} from '@angular/material/icon';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatExpansionModule} from '@angular/material/expansion';
import {createCustomElement} from '@angular/elements';
import {Injector, NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {MatInputModule} from '@angular/material/input';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {MatButtonModule} from '@angular/material/button';
import {FondsportfolioVermittlerspezifischComponent} from './fondsportfolio-vermittlerspezifisch.component';
import {
  FondsportfolioVermittlerspezifischVerwaltungComponent
} from './fondsportfolio-vermittlerspezifisch-verwaltung/fondsportfolio-vermittlerspezifisch-verwaltung.component';
import {
  FondsportfolioVermittlerspezifischAntragComponent
} from './fondsportfolio-vermittlerspezifisch-antrag/fondsportfolio-vermittlerspezifisch-antrag.component';

@NgModule({
  declarations: [
    FondsportfolioVermittlerspezifischComponent,
    FondsportfolioVermittlerspezifischVerwaltungComponent,
    FondsportfolioVermittlerspezifischAntragComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    MatIconModule,
    MatFormFieldModule,
    MatProgressSpinnerModule,
    MatExpansionModule,
    FormsModule,
    MatInputModule,
    MatButtonModule
  ],
  exports: [FondsportfolioVermittlerspezifischComponent]
})
export class FondsportfolioVermittlerspezifischModule {
  constructor(private injector: Injector) {
  }

  addCustomElements() {
    if (!customElements.get('lv-fondsportfolio-vermittlerspezifisch')) {
      const appComponent = createCustomElement(FondsportfolioVermittlerspezifischComponent, {injector: this.injector});
      customElements.define('lv-fondsportfolio-vermittlerspezifisch', appComponent);
    }
  }
}
